import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaPlus, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import TableEmptyState from "../ReusableComponents/TableEmptyState";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';



const AvaliadoresVinculados = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_avaliadores, setLoadingavaliadores] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [avaliadores, setavaliadores] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name, online } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [avaliadores_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const [loading_zip, setLoadingZip] = useState(false);
  const [message_zip, setMessageZip] = useState('');

  const [loading_zip2, setLoadingZip2] = useState(false);
  const [message_zip2, setMessageZip2] = useState('');
  const timerRef = useRef(null);

  const user = useSelector((state) => state.AppReducer.user);



  const Getavaliadores = async (page, search) => {

    let response = await Request.Get(`faculdade/get_avaliadores_vinculados/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    console.log(search);
    console.log(search_oficial);
    console.log(page);


    if (response.pagination.current_page == page) {

      setavaliadores(response.avaliadores);

      setPagination(response.pagination);
      props.setState({total_evaluators:response.pagination.total_pages})

      setLoadingScreen(false);
      setLoadingavaliadores(false);


    }
  };





  const DeleteRedacao = async (avaliadores_id) => {

    let response = await Request.Delete(`faculdade/desvincular_avaliador/${avaliadores_id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getavaliadores(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getavaliadores(1, search_oficial);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  const GetPdfsZip = async () => {

    let response = await Request.Get(`faculdade/download_pdfs_images/` + processo_id);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'redacoes_processo_'+processo_name+'.zip');
    // }
    else {
      if (response['status'] == true) {
        document.getElementById('download_link').href = response['path'];
        document.getElementById('download_link').click();
        setLoadingZip2(false);
        setMessageZip2('');

        return;
      } else
      if (response['status'] != 'Error') {
        setMessageZip2(response['message']);
      }
      timerRef.current = setTimeout(() => {
        GetPdfsZip();
      }, 20000);

    }


  };

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <>

            <a id="download_link" target="_blank"></a>


            {/* <hr /> */}
            {loading_screen == false && <div className="module-card-container">

                <div className="module-breadcrumb">

                    <button
            className="breadcrumb-back"
            onClick={() =>
            props.setState({
              activeTab: -1
            })
            }>{t("dashboard")}


          </button>

                    <span>/</span>

                    <strong>{t("evaluators")}</strong>

                </div>

                <div className="module-title-row">

                    <div>

                        <h3 style={{ fontWeight: 'bold' }}>{`
                            ${t("evaluators")}
                        `}</h3>

                        <p>{t("ui_gerencie_os_avaliadores_vinculados_ao_processo_e1675ff5")}

            </p>

                    </div>

                    <button
            className="btn-dashboard-modern"
            onClick={() =>
            props.setState({
              activeTab: -1
            })
            }>{`
                        ${t("legacy_dashboard")}
                    `}
          </button>

                </div>

                <div className="module-toolbar">

                    <Search
            placeholder={t("placeholder_search_evaluator")}
            ValueChange={(value) => {

              clearTimeout(pesquisarTimeout);

              setSearchOficial(value);

              pesquisarTimeout = setTimeout(() => {

                let page = { ...pagination };

                page.current_page = 1;

                setPagination(page);

                setLoadingavaliadores(true);

                Getavaliadores(1, value);

              }, 500);

            }} />


                    <div className="module-actions">

                        <Link
              to={`/avaliadores_vinculados/register/${processo_id}`}
              className="btn-module-primary">


                            <FaPlus />{`

                            ${t("legacy_adicionar_avaliadores")}

                        `}</Link>

                    </div>

                </div>

                <div className="table-modern-card">
                    <table id="tech-companies-1" className="table table-striped">
                        <thead>
                            <tr>

                                <th>{t("label_name")}</th>
                                <th>{t("label_email")}</th>

                                <th data-priority="3">{t("label_actions")}</th>

                            </tr>
                        </thead>
                        <tbody>
                            {loading_avaliadores == false && avaliadores.map((item, id) =>

              <tr key={id}>
                                    <td>

                                        <div className="redacao-name">

                                            <strong>
                                                {item.name}
                                            </strong>

                                        </div>

                                    </td>
                                    <td>

                                        <div className="redacao-preview">

                                            {item.email}

                                        </div>

                                    </td>


                                    <td>

                                        <div className="actions-group">

                                            {item.deleted_at == null &&

                    <button
                      className="action-btn danger"
                      onClick={() => {

                        setRedacaoId(item.id);

                        setShowWarning(true);

                      }}>

                                                    <MdDelete />
                                                </button>

                    }

                                        </div>

                                    </td>

                                </tr>
              )}

                        </tbody>
                    </table>
                    {loading_avaliadores == true &&
          <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                            {/* <div className="spinner-border text-primary" role="status"  >
                </div> */}
                            <CircularProgress />
                        </div></div>

          }
                </div>
                {loading_avaliadores == false && avaliadores.length == 0 && <TableEmptyState title={t("empty_no_evaluator_found")} icon="⭐" />}

                <Pagination
          className={pagination.last_page == 1 ? "hide" : ""}
          style={{ display: "flex", justifyContent: "flex-end" }}
          count={pagination.last_page}
          value={pagination.current_page}
          onChange={(_, value) => {
            setLoadingavaliadores(true);
            console.log(_, value);
            let page = { ...pagination };
            page.current_page = value;
            setPagination(pagination);
            Getavaliadores(value, search_oficial);
          }} />


                {/* {this.state.andamento == true && <AvaliacaoAndamento get_avaliadores={this.get_avaliadores.bind(this)} {...this.props} />} */}

            </div>}

            {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                {/* <div className="spinner-border text-primary" role="status"  >
            </div> */}
                <CircularProgress />
            </div></div>}

            <SweetAlert
        warning
        title={t("legacy_atencao")}
        onConfirm={() => {
          setShowWarning(false);
          setLoadingavaliadores(true);
          DeleteRedacao(avaliadores_id);
          // this.delete_banner(this.state.banner_to_delete);
        }}
        onCancel={() => {
          setShowWarning(false);
        }}
        show={show_warning}
        confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
        cancelBtnText={t("legacy_cancelar")}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        showCancel={true}>{t("ui_ao_desvincular_este_avaliador_ele_nao_tera_mais_ac_341570a9")}


      </SweetAlert>



        </>);

};

export default AvaliadoresVinculados;
